import uiHeader from '@/pages/components/uiHeader/uiHeader'
import uiFooter from '@/pages/components/uiFooter/uiFooter'

export default {
  name: 'home',
  data() {
    return {
      imgs: {
        zh: {
          about: require(`./img/zh/about.png`),
          t1: require(`./img/zh/t1-1.png`),
          t2: require(`./img/zh/t1-2.png`),
          t3: require(`./img/zh/t1-3.png`),
          t4: require(`./img/zh/t1-4.png`),
          banner: require(`./img/zh/banner.png`),
        },
        en: {
          about: require(`./img/zh/about.png`),
          t1: require(`./img/en/t1-1.png`),
          t2: require(`./img/en/t1-2.png`),
          t3: require(`./img/en/t1-3.png`),
          t4: require(`./img/en/t1-4.png`),
          banner: require(`./img/en/banner.png`),
        },
        jp: {
          about: require(`./img/zh/about.png`),
          t1: require(`./img/jp/t1-1.png`),
          t2: require(`./img/jp/t1-2.png`),
          t3: require(`./img/jp/t1-3.png`),
          t4: require(`./img/jp/t1-4.png`),
          banner: require(`./img/jp/banner.png`),
        }
      },
      lang: this.$i18n.locale
    }
  },
  components: {
    uiHeader,
    uiFooter
  },
  methods: {
    changeLang(lang){
      this.lang = lang
    },
    getImgUrl(name){
      console.log(this.imgs[this.lang][name])
      return this.imgs[this.lang][name]
    },
    jump(){
      this.$router.push({name: 'resourceShow'})
    },
    jumpSub(num) {
      this.$router.push({name: 'layout', query: {num}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.js